import { useMemo } from 'react'
import { Node } from 'reactflow'
import { RailTrackWithActions } from '../models/yard-view.model'
import { RailTrackViewStore } from '../stores/nodes/rail-track.view-store'
import { YardViewStore } from '../stores/yard.view-store'

const FOCUSED_Z_INDEX = 1000

export const useRailTrackNodes = (
  viewStore: YardViewStore,
  railTrackViewStore: RailTrackViewStore,
): Node<RailTrackWithActions>[] =>
  useMemo<Node<RailTrackWithActions>[]>(
    () =>
      viewStore.railTracks.map(railTrack => ({
        id: railTrack.id,
        type: 'railTrack',
        ...(viewStore.focusedRailTrackId === railTrack.id && { zIndex: FOCUSED_Z_INDEX }),
        position: {
          x: railTrack.layoutPosition.x,
          y: railTrack.layoutPosition.y,
        },
        data: {
          ...railTrack,
          isEditable: !viewStore.isViewMode,
          showNodeHeaders: viewStore.showNodeHeaders,
          focused: viewStore.focusedRailTrackId === railTrack.id,
          onEdit: railTrackViewStore.openFormDialog,
          onFocus: viewStore.setFocusedRailTrackId,
          onDelete: railTrackViewStore.setDeleteDialogOpen,
          onRotate: railTrackViewStore.setRotation,
        },
      })),
    [
      viewStore.railTracks,
      viewStore.focusedRailTrackId,
      viewStore.isViewMode,
      viewStore.showNodeHeaders,
      viewStore.setFocusedRailTrackId,
      railTrackViewStore,
    ],
  )
